@layer components {
  .verses {
    --buttons-height: calc(50px + var(--space-large));
    --back-height: calc(16px * 1.5 + 2 * 4px + 2px);
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
    max-width: 1000px;
    padding: var(--space-medium);
    margin: 0 auto;

    /* Przewijanie do wersetu z fokusem zostawia miejsce na przyklejone panele. */
    > [data-id] {
      scroll-margin-top: calc(var(--controls-height) + var(--space-small));
      scroll-margin-bottom: calc(var(--buttons-height) + var(--space-medium));
    }

    /* Przycisk powrotu do wyników jest przyklejony pod panelem, więc werset musi zatrzymać się niżej. */
    &:has(> .back) > [data-id] {
      scroll-margin-top: calc(var(--controls-height) + var(--space-small) + var(--back-height) + var(--space-small));
    }

    &:empty::before, &:has(> .back:only-child)::before {
      content: '';
      position: absolute;
      top: 50vh;
      left: 50vw;
      width: 30px;
      height: 30px;
      border: 3px solid var(--white);
      border-top-color: transparent;
      border-radius: 50%;
      animation: spinner 1s infinite linear;
    }
  }

  .back {
    position: sticky;
    top: calc(var(--controls-height) + var(--space-small));
    z-index: 1;
    align-self: flex-start;
    margin-bottom: var(--space-small);

    button:not(:hover, :focus-visible) {
      background-color: var(--navy);
      border-color: var(--navy);
    }
  }

  .info {
    padding: var(--space-small);
    opacity: 0.5;
    text-align: center;
  }
}

@keyframes spinner {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
